module.exports = __webpack_public_path__ + "static/media/neapolitan_cake.bd4789f8.jpg";